import { useParams, useNavigate, useLocation } from "react-router-dom";
import React, { useState, useContext, useEffect } from "react";
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { AppContext } from "../../context/AppContext";
import Swal from "sweetalert2";
import axios from "axios";
import GetToken from "../../GetToken";
import { handleInvalidToken } from "../../AuthUtils";
import AnimationSpinner from '../../AnimationSpinner';
// import custom component
import BookTemplate from '../../components/custom-components/BookFlow/templateComponent/BookTemplate';
import BookIndex from "../../components/custom-components/BookFlow/indexComponent/BookIndex";
import BookEditor from "../chapterEditor/Editor";
import AvatarPage from "../../components/custom-components/BookFlow/avtarComponent/AvatarPage";



// Material UI import
import Button from "@mui/material/Button";

const steps = ['Basic details', 'Book Cover', 'Index', 'Customize Book', 'Avatar Customization'];

const TalkingBook = () => {
    const [activeStep, setActiveStep] = useState(1);
    const { slug } = useParams();
    const { isSidebarOpen, setIsSidebarOpen } = useContext(AppContext);
    const location = useLocation();
 
    useEffect(() => {
        if (activeStep == 3) {
            setIsSidebarOpen(false);
        } else {
            setIsSidebarOpen(true);
        }
    }, [activeStep, location]);

    return (
        <div className="right-container">
            {activeStep == 1 && <BookTemplate bookToken={slug} activeStep={activeStep} setActiveStep={setActiveStep} steps={steps} />}
            {activeStep == 2 && <BookIndex bookToken={slug} activeStep={activeStep} setActiveStep={setActiveStep} steps={steps} />}
            {activeStep == 3 && <BookEditor bookToken={slug} activeStep={activeStep} setActiveStep={setActiveStep} steps={steps} />}
            {activeStep == 4 && <AvatarPage bookToken={slug} activeStep={activeStep} setActiveStep={setActiveStep} steps={steps} />}
        </div>
    );
};

export default TalkingBook;
